module.exports = [{"type":"hash","text":"連接限制"},{"type":"normal","text":"一個websocket限制最多200個topic，超過將返回100416錯誤碼。"},{"type":"normal","text":"一個IP限制最多60個websocket，超過將返回100419錯誤碼。"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/introduce/01_limit.json
// module id = WMCK
// module chunks = 3